import { render, staticRenderFns } from "./OpenserveAccount.vue?vue&type=template&id=c7e0d968&"
import script from "./OpenserveAccount.vue?vue&type=script&lang=js&"
export * from "./OpenserveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports